import api from './api';
import { Product, ProductFilters, PaginationInfo, Category } from '../types';
import { normalizeProduct } from '../utils/helpers';

export const productService = {
    // Get products with filtering and pagination
    getProducts: async (filters: ProductFilters = {}, includeUnavailable: boolean = false): Promise<{
        products: Product[];
        pagination: PaginationInfo;
    }> => {
        const params = new URLSearchParams();

        Object.entries(filters).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                params.append(key, value.toString());
            }
        });

        // Add includeUnavailable parameter for admin use
        if (includeUnavailable) {
            params.append('includeUnavailable', 'true');
        }

        const response = await api.get(`/products?${params.toString()}`);
        return {
            products: (response.data.products || response.data.data || []).map(normalizeProduct),
            pagination: response.data.pagination || {
                currentPage: 1,
                totalPages: 1,
                totalItems: response.data.products?.length || response.data.data?.length || 0,
                itemsPerPage: response.data.products?.length || response.data.data?.length || 0
            }
        };
    },

    // Get single product by ID
    getProductById: async (id: number): Promise<{ product: Product }> => {
        const response = await api.get(`/products/${id}`);
        return { product: normalizeProduct(response.data.product || response.data.data) };
    },

    // Get featured products
    getFeaturedProducts: async (limit: number = 10): Promise<{ products: Product[] }> => {
        const response = await api.get(`/products?limit=${limit}`);
        return { products: (response.data.products || response.data.data || []).map(normalizeProduct) };
    },

    // Get categories
    getCategories: async (): Promise<{ categories: Category[] }> => {
        const response = await api.get('/categories');
        console.log('Categories API response:', response.data);
        return { categories: response.data.categories || response.data.data || [] };
    },

    // Admin: Create product
    createProduct: async (productData: Partial<Product>): Promise<{ message: string; productId: number }> => {
        const response = await api.post('/products', productData);
        return response.data;
    },

    // Admin: Update product
    updateProduct: async (id: number, productData: Partial<Product>): Promise<{ message: string }> => {
        const response = await api.put(`/products/${id}`, productData);
        return response.data;
    },

    // Admin: Delete product
    deleteProduct: async (id: number): Promise<{ message: string }> => {
        const response = await api.delete(`/products/${id}`);
        return response.data;
    },
};
